import gql from 'graphql-tag';

export const mutationSendIntegrationEmailReply = gql`
  mutation sendIntegrationEmailReply (
    $integrationID: DokkioID!
    $remoteID: ID!
    $emailReplyType: EmailReplyType!
    $toAddress: String
    $messageText: String!
  ) {
    sendIntegrationEmailReply (
      integrationID: $integrationID
      remoteID: $remoteID
      emailReplyType: $emailReplyType
      toAddress: $toAddress
      messageText: $messageText
    )
  }
`;
export default mutationSendIntegrationEmailReply;
